import { TFunction } from "i18next";
import * as yup from "yup";
import { ValidationMessagesUtils } from "../../../utils/yup";

export default function newQuoteTemplateSchema(t: TFunction) {
  return yup.object().shape({
    name: yup.string(),
  });
}
